export default __webpack_public_path__ + "static/media/OpenSource.dbd5da2e.png";